@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.treedetail.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.treedetail.resources/"

@delegate:ResourceContentHash(-1_721_916_154)
internal val Res.string.treedetail_back_description: StringResource by lazy {
      StringResource("string:treedetail_back_description", "treedetail_back_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 43),
      ))
    }

@delegate:ResourceContentHash(1_719_688_900)
internal val Res.string.treedetail_certainty_certain: StringResource by lazy {
      StringResource("string:treedetail_certainty_certain", "treedetail_certainty_certain", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54, 48),
      ))
    }

@delegate:ResourceContentHash(-2_083_757_757)
internal val Res.string.treedetail_certainty_probable: StringResource by lazy {
      StringResource("string:treedetail_certainty_probable", "treedetail_certainty_probable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103, 49),
      ))
    }

@delegate:ResourceContentHash(516_503_600)
internal val Res.string.treedetail_certainty_to_confirm: StringResource by lazy {
      StringResource("string:treedetail_certainty_to_confirm", "treedetail_certainty_to_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153, 55),
      ))
    }

@delegate:ResourceContentHash(956_385_158)
internal val Res.string.treedetail_confidence_disclaimer: StringResource by lazy {
      StringResource("string:treedetail_confidence_disclaimer", "treedetail_confidence_disclaimer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209, 176),
      ))
    }

@delegate:ResourceContentHash(1_961_183_253)
internal val Res.string.treedetail_confidence_label: StringResource by lazy {
      StringResource("string:treedetail_confidence_label", "treedetail_confidence_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 386, 47),
      ))
    }

@delegate:ResourceContentHash(508_629_890)
internal val Res.string.treedetail_confidence_lookalike_collapse: StringResource by lazy {
      StringResource("string:treedetail_confidence_lookalike_collapse", "treedetail_confidence_lookalike_collapse", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 434, 60),
      ))
    }

@delegate:ResourceContentHash(726_929_034)
internal val Res.string.treedetail_confidence_lookalike_expand: StringResource by lazy {
      StringResource("string:treedetail_confidence_lookalike_expand", "treedetail_confidence_lookalike_expand", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 495, 58),
      ))
    }

@delegate:ResourceContentHash(1_308_006_051)
internal val Res.string.treedetail_confidence_lookalike_title: StringResource by lazy {
      StringResource("string:treedetail_confidence_lookalike_title", "treedetail_confidence_lookalike_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 554, 77),
      ))
    }

@delegate:ResourceContentHash(-924_314_866)
internal val Res.string.treedetail_confidence_owner_note: StringResource by lazy {
      StringResource("string:treedetail_confidence_owner_note", "treedetail_confidence_owner_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 782, 132),
      ))
    }

@delegate:ResourceContentHash(39_188_996)
internal val Res.string.treedetail_confidence_owner_note_disputed: StringResource by lazy {
      StringResource("string:treedetail_confidence_owner_note_disputed", "treedetail_confidence_owner_note_disputed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 632, 149),
      ))
    }

@delegate:ResourceContentHash(844_204_890)
internal val Res.string.treedetail_confidence_report_cta: StringResource by lazy {
      StringResource("string:treedetail_confidence_report_cta", "treedetail_confidence_report_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 915, 56),
      ))
    }

@delegate:ResourceContentHash(-1_835_002_922)
internal val Res.string.treedetail_confidence_subtitle_disputed: StringResource by lazy {
      StringResource("string:treedetail_confidence_subtitle_disputed", "treedetail_confidence_subtitle_disputed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 972, 83),
      ))
    }

@delegate:ResourceContentHash(-1_434_809_506)
internal val Res.string.treedetail_creator_added_recently: StringResource by lazy {
      StringResource("string:treedetail_creator_added_recently", "treedetail_creator_added_recently", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1056, 65),
      ))
    }

@delegate:ResourceContentHash(948_408_213)
internal val Res.string.treedetail_default_username: StringResource by lazy {
      StringResource("string:treedetail_default_username", "treedetail_default_username", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1122, 55),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.treedetail_delete_dialog_cancel: StringResource by lazy {
      StringResource("string:treedetail_delete_dialog_cancel", "treedetail_delete_dialog_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1178, 51),
      ))
    }

@delegate:ResourceContentHash(-981_801_054)
internal val Res.string.treedetail_delete_dialog_confirm: StringResource by lazy {
      StringResource("string:treedetail_delete_dialog_confirm", "treedetail_delete_dialog_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1230, 52),
      ))
    }

@delegate:ResourceContentHash(-953_241_879)
internal val Res.string.treedetail_delete_dialog_text: StringResource by lazy {
      StringResource("string:treedetail_delete_dialog_text", "treedetail_delete_dialog_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1283, 193),
      ))
    }

@delegate:ResourceContentHash(-87_463_677)
internal val Res.string.treedetail_delete_dialog_title: StringResource by lazy {
      StringResource("string:treedetail_delete_dialog_title", "treedetail_delete_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1477, 66),
      ))
    }

@delegate:ResourceContentHash(1_563_756_191)
internal val Res.string.treedetail_directions: StringResource by lazy {
      StringResource("string:treedetail_directions", "treedetail_directions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1544, 41),
      ))
    }

@delegate:ResourceContentHash(-524_662_897)
internal val Res.string.treedetail_failed_photos_remove: StringResource by lazy {
      StringResource("string:treedetail_failed_photos_remove", "treedetail_failed_photos_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1586, 51),
      ))
    }

@delegate:ResourceContentHash(1_420_507_852)
internal val Res.string.treedetail_failed_photos_retry: StringResource by lazy {
      StringResource("string:treedetail_failed_photos_retry", "treedetail_failed_photos_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1638, 54),
      ))
    }

@delegate:ResourceContentHash(-1_220_210_825)
internal val Res.string.treedetail_failed_photos_text_many: StringResource by lazy {
      StringResource("string:treedetail_failed_photos_text_many", "treedetail_failed_photos_text_many", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1693, 102),
      ))
    }

@delegate:ResourceContentHash(715_695_045)
internal val Res.string.treedetail_failed_photos_text_one: StringResource by lazy {
      StringResource("string:treedetail_failed_photos_text_one", "treedetail_failed_photos_text_one", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1796, 177),
      ))
    }

@delegate:ResourceContentHash(-1_919_269_874)
internal val Res.string.treedetail_failed_photos_title_many: StringResource by lazy {
      StringResource("string:treedetail_failed_photos_title_many", "treedetail_failed_photos_title_many", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1974, 83),
      ))
    }

@delegate:ResourceContentHash(-947_147_804)
internal val Res.string.treedetail_failed_photos_title_one: StringResource by lazy {
      StringResource("string:treedetail_failed_photos_title_one", "treedetail_failed_photos_title_one", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2058, 78),
      ))
    }

@delegate:ResourceContentHash(1_336_409_116)
internal val Res.string.treedetail_field_creation: StringResource by lazy {
      StringResource("string:treedetail_field_creation", "treedetail_field_creation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2137, 45),
      ))
    }

@delegate:ResourceContentHash(-214_905)
internal val Res.string.treedetail_field_note: StringResource by lazy {
      StringResource("string:treedetail_field_note", "treedetail_field_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2183, 37),
      ))
    }

@delegate:ResourceContentHash(68_938_561)
internal val Res.string.treedetail_field_position: StringResource by lazy {
      StringResource("string:treedetail_field_position", "treedetail_field_position", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2221, 45),
      ))
    }

@delegate:ResourceContentHash(694_727_719)
internal val Res.string.treedetail_field_species: StringResource by lazy {
      StringResource("string:treedetail_field_species", "treedetail_field_species", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2267, 44),
      ))
    }

@delegate:ResourceContentHash(-1_044_443_951)
internal val Res.string.treedetail_harvest_status_cancelled: StringResource by lazy {
      StringResource("string:treedetail_harvest_status_cancelled", "treedetail_harvest_status_cancelled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2312, 55),
      ))
    }

@delegate:ResourceContentHash(-2_088_502_479)
internal val Res.string.treedetail_harvest_status_completed: StringResource by lazy {
      StringResource("string:treedetail_harvest_status_completed", "treedetail_harvest_status_completed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2368, 55),
      ))
    }

@delegate:ResourceContentHash(-1_716_526_061)
internal val Res.string.treedetail_harvest_status_expired: StringResource by lazy {
      StringResource("string:treedetail_harvest_status_expired", "treedetail_harvest_status_expired", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2424, 53),
      ))
    }

@delegate:ResourceContentHash(762_899_012)
internal val Res.string.treedetail_harvest_status_ongoing: StringResource by lazy {
      StringResource("string:treedetail_harvest_status_ongoing", "treedetail_harvest_status_ongoing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2478, 53),
      ))
    }

@delegate:ResourceContentHash(-62_704_192)
internal val Res.string.treedetail_harvest_status_planned: StringResource by lazy {
      StringResource("string:treedetail_harvest_status_planned", "treedetail_harvest_status_planned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2532, 53),
      ))
    }

@delegate:ResourceContentHash(-567_474_407)
internal val Res.string.treedetail_hazard_lookalike_note: StringResource by lazy {
      StringResource("string:treedetail_hazard_lookalike_note", "treedetail_hazard_lookalike_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2586, 120),
      ))
    }

@delegate:ResourceContentHash(1_904_388_024)
internal val Res.string.treedetail_hazard_title: StringResource by lazy {
      StringResource("string:treedetail_hazard_title", "treedetail_hazard_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2707, 91),
      ))
    }

@delegate:ResourceContentHash(-1_895_022_520)
internal val Res.string.treedetail_header_added_by: StringResource by lazy {
      StringResource("string:treedetail_header_added_by", "treedetail_header_added_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2857, 58),
      ))
    }

@delegate:ResourceContentHash(912_118_430)
internal val Res.string.treedetail_header_added_by_me: StringResource by lazy {
      StringResource("string:treedetail_header_added_by_me", "treedetail_header_added_by_me", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2799, 57),
      ))
    }

@delegate:ResourceContentHash(-725_192_519)
internal val Res.string.treedetail_history_author_line: StringResource by lazy {
      StringResource("string:treedetail_history_author_line", "treedetail_history_author_line", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2916, 54),
      ))
    }

@delegate:ResourceContentHash(1_174_905_398)
internal val Res.string.treedetail_history_author_unnamed: StringResource by lazy {
      StringResource("string:treedetail_history_author_unnamed", "treedetail_history_author_unnamed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2971, 57),
      ))
    }

@delegate:ResourceContentHash(-550_230_126)
internal val Res.string.treedetail_history_changed: StringResource by lazy {
      StringResource("string:treedetail_history_changed", "treedetail_history_changed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3029, 46),
      ))
    }

@delegate:ResourceContentHash(-563_245_048)
internal val Res.string.treedetail_history_current: StringResource by lazy {
      StringResource("string:treedetail_history_current", "treedetail_history_current", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3076, 58),
      ))
    }

@delegate:ResourceContentHash(1_528_257_318)
internal val Res.string.treedetail_history_error_title: StringResource by lazy {
      StringResource("string:treedetail_history_error_title", "treedetail_history_error_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3135, 78),
      ))
    }

@delegate:ResourceContentHash(879_446_259)
internal val Res.string.treedetail_history_import_bordeaux: StringResource by lazy {
      StringResource("string:treedetail_history_import_bordeaux", "treedetail_history_import_bordeaux", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3214, 86),
      ))
    }

@delegate:ResourceContentHash(-2_062_825_710)
internal val Res.string.treedetail_history_import_grenoble: StringResource by lazy {
      StringResource("string:treedetail_history_import_grenoble", "treedetail_history_import_grenoble", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3301, 94),
      ))
    }

@delegate:ResourceContentHash(-1_653_001_218)
internal val Res.string.treedetail_history_import_lozere: StringResource by lazy {
      StringResource("string:treedetail_history_import_lozere", "treedetail_history_import_lozere", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3396, 96),
      ))
    }

@delegate:ResourceContentHash(1_080_585_551)
internal val Res.string.treedetail_history_import_lyon: StringResource by lazy {
      StringResource("string:treedetail_history_import_lyon", "treedetail_history_import_lyon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3493, 86),
      ))
    }

@delegate:ResourceContentHash(-1_045_969_274)
internal val Res.string.treedetail_history_import_metz: StringResource by lazy {
      StringResource("string:treedetail_history_import_metz", "treedetail_history_import_metz", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3580, 90),
      ))
    }

@delegate:ResourceContentHash(632_527_276)
internal val Res.string.treedetail_history_import_montpellier: StringResource by lazy {
      StringResource("string:treedetail_history_import_montpellier", "treedetail_history_import_montpellier", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3671, 113),
      ))
    }

@delegate:ResourceContentHash(-977_808_398)
internal val Res.string.treedetail_history_import_nantes: StringResource by lazy {
      StringResource("string:treedetail_history_import_nantes", "treedetail_history_import_nantes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3785, 84),
      ))
    }

@delegate:ResourceContentHash(-940_187_982)
internal val Res.string.treedetail_history_import_osm: StringResource by lazy {
      StringResource("string:treedetail_history_import_osm", "treedetail_history_import_osm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3870, 65),
      ))
    }

@delegate:ResourceContentHash(1_828_636_819)
internal val Res.string.treedetail_history_import_paris: StringResource by lazy {
      StringResource("string:treedetail_history_import_paris", "treedetail_history_import_paris", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3936, 83),
      ))
    }

@delegate:ResourceContentHash(550_010_178)
internal val Res.string.treedetail_history_import_plaine_commune: StringResource by lazy {
      StringResource("string:treedetail_history_import_plaine_commune", "treedetail_history_import_plaine_commune", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4020, 88),
      ))
    }

@delegate:ResourceContentHash(934_593_178)
internal val Res.string.treedetail_history_import_rennes: StringResource by lazy {
      StringResource("string:treedetail_history_import_rennes", "treedetail_history_import_rennes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4109, 84),
      ))
    }

@delegate:ResourceContentHash(1_995_855_562)
internal val Res.string.treedetail_history_import_strasbourg: StringResource by lazy {
      StringResource("string:treedetail_history_import_strasbourg", "treedetail_history_import_strasbourg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4194, 104),
      ))
    }

@delegate:ResourceContentHash(-1_175_020_023)
internal val Res.string.treedetail_history_import_toulouse: StringResource by lazy {
      StringResource("string:treedetail_history_import_toulouse", "treedetail_history_import_toulouse", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4299, 86),
      ))
    }

@delegate:ResourceContentHash(-605_177_800)
internal val Res.string.treedetail_history_moved: StringResource by lazy {
      StringResource("string:treedetail_history_moved", "treedetail_history_moved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4448, 60),
      ))
    }

@delegate:ResourceContentHash(946_274_692)
internal val Res.string.treedetail_history_moved_back: StringResource by lazy {
      StringResource("string:treedetail_history_moved_back", "treedetail_history_moved_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4386, 61),
      ))
    }

@delegate:ResourceContentHash(-898_131_111)
internal val Res.string.treedetail_history_no_certainty: StringResource by lazy {
      StringResource("string:treedetail_history_no_certainty", "treedetail_history_no_certainty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4509, 59),
      ))
    }

@delegate:ResourceContentHash(-729_035_626)
internal val Res.string.treedetail_history_note_added: StringResource by lazy {
      StringResource("string:treedetail_history_note_added", "treedetail_history_note_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4569, 49),
      ))
    }

@delegate:ResourceContentHash(-182_499_600)
internal val Res.string.treedetail_history_note_cleared: StringResource by lazy {
      StringResource("string:treedetail_history_note_cleared", "treedetail_history_note_cleared", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4619, 51),
      ))
    }

@delegate:ResourceContentHash(-550_230_126)
internal val Res.string.treedetail_history_note_edited: StringResource by lazy {
      StringResource("string:treedetail_history_note_edited", "treedetail_history_note_edited", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4671, 50),
      ))
    }

@delegate:ResourceContentHash(2_074_252_277)
internal val Res.string.treedetail_history_reason: StringResource by lazy {
      StringResource("string:treedetail_history_reason", "treedetail_history_reason", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4722, 49),
      ))
    }

@delegate:ResourceContentHash(-527_779_983)
internal val Res.string.treedetail_history_redacted: StringResource by lazy {
      StringResource("string:treedetail_history_redacted", "treedetail_history_redacted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4772, 83),
      ))
    }

@delegate:ResourceContentHash(-545_999_687)
internal val Res.string.treedetail_history_reverted: StringResource by lazy {
      StringResource("string:treedetail_history_reverted", "treedetail_history_reverted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4856, 59),
      ))
    }

@delegate:ResourceContentHash(-1_254_429_686)
internal val Res.string.treedetail_history_subtitle: StringResource by lazy {
      StringResource("string:treedetail_history_subtitle", "treedetail_history_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4916, 123),
      ))
    }

@delegate:ResourceContentHash(-848_126_210)
internal val Res.string.treedetail_history_title: StringResource by lazy {
      StringResource("string:treedetail_history_title", "treedetail_history_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5040, 48),
      ))
    }

@delegate:ResourceContentHash(49_491_390)
internal val Res.string.treedetail_history_truncated: StringResource by lazy {
      StringResource("string:treedetail_history_truncated", "treedetail_history_truncated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5089, 104),
      ))
    }

@delegate:ResourceContentHash(-1_966_280_187)
internal val Res.string.treedetail_identity_add_note: StringResource by lazy {
      StringResource("string:treedetail_identity_add_note", "treedetail_identity_add_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5194, 60),
      ))
    }

@delegate:ResourceContentHash(1_832_006_239)
internal val Res.string.treedetail_identity_correct: StringResource by lazy {
      StringResource("string:treedetail_identity_correct", "treedetail_identity_correct", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5255, 47),
      ))
    }

@delegate:ResourceContentHash(1_936_746_707)
internal val Res.string.treedetail_identity_edit_note: StringResource by lazy {
      StringResource("string:treedetail_identity_edit_note", "treedetail_identity_edit_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5303, 49),
      ))
    }

@delegate:ResourceContentHash(-2_079_909_516)
internal val Res.string.treedetail_identity_footer_corrected: StringResource by lazy {
      StringResource("string:treedetail_identity_footer_corrected", "treedetail_identity_footer_corrected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5431, 76),
      ))
    }

@delegate:ResourceContentHash(-1_498_668_722)
internal val Res.string.treedetail_identity_footer_corrected_mine: StringResource by lazy {
      StringResource("string:treedetail_identity_footer_corrected_mine", "treedetail_identity_footer_corrected_mine", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5353, 77),
      ))
    }

@delegate:ResourceContentHash(262_093_442)
internal val Res.string.treedetail_identity_footer_inventory: StringResource by lazy {
      StringResource("string:treedetail_identity_footer_inventory", "treedetail_identity_footer_inventory", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5508, 92),
      ))
    }

@delegate:ResourceContentHash(199_852_832)
internal val Res.string.treedetail_identity_footer_moderation: StringResource by lazy {
      StringResource("string:treedetail_identity_footer_moderation", "treedetail_identity_footer_moderation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5601, 69),
      ))
    }

@delegate:ResourceContentHash(406_588_177)
internal val Res.string.treedetail_identity_footer_never: StringResource by lazy {
      StringResource("string:treedetail_identity_footer_never", "treedetail_identity_footer_never", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5671, 68),
      ))
    }

@delegate:ResourceContentHash(-1_083_902_068)
internal val Res.string.treedetail_identity_footer_osm: StringResource by lazy {
      StringResource("string:treedetail_identity_footer_osm", "treedetail_identity_footer_osm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5740, 94),
      ))
    }

@delegate:ResourceContentHash(-848_126_210)
internal val Res.string.treedetail_identity_history: StringResource by lazy {
      StringResource("string:treedetail_identity_history", "treedetail_identity_history", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5835, 51),
      ))
    }

@delegate:ResourceContentHash(719_475_020)
internal val Res.string.treedetail_identity_move: StringResource by lazy {
      StringResource("string:treedetail_identity_move", "treedetail_identity_move", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5887, 44),
      ))
    }

@delegate:ResourceContentHash(400_100_885)
internal val Res.string.treedetail_identity_note_empty: StringResource by lazy {
      StringResource("string:treedetail_identity_note_empty", "treedetail_identity_note_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5932, 62),
      ))
    }

@delegate:ResourceContentHash(-214_905)
internal val Res.string.treedetail_identity_note_label: StringResource by lazy {
      StringResource("string:treedetail_identity_note_label", "treedetail_identity_note_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5995, 46),
      ))
    }

@delegate:ResourceContentHash(68_938_561)
internal val Res.string.treedetail_identity_position_label: StringResource by lazy {
      StringResource("string:treedetail_identity_position_label", "treedetail_identity_position_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6042, 54),
      ))
    }

@delegate:ResourceContentHash(1_719_682_390)
internal val Res.string.treedetail_identity_sheet_certain: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_certain", "treedetail_identity_sheet_certain", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6309, 53),
      ))
    }

@delegate:ResourceContentHash(-264_093_939)
internal val Res.string.treedetail_identity_sheet_certain_description: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_certain_description", "treedetail_identity_sheet_certain_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6097, 121),
      ))
    }

@delegate:ResourceContentHash(-440_587_827)
internal val Res.string.treedetail_identity_sheet_certainty_title: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_certainty_title", "treedetail_identity_sheet_certainty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6219, 89),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.treedetail_identity_sheet_close: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_close", "treedetail_identity_sheet_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6363, 47),
      ))
    }

@delegate:ResourceContentHash(1_439_708_938)
internal val Res.string.treedetail_identity_sheet_current: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_current", "treedetail_identity_sheet_current", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6411, 69),
      ))
    }

@delegate:ResourceContentHash(-1_075_094_939)
internal val Res.string.treedetail_identity_sheet_doubt: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_doubt", "treedetail_identity_sheet_doubt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6554, 91),
      ))
    }

@delegate:ResourceContentHash(1_765_009_878)
internal val Res.string.treedetail_identity_sheet_doubt_withdraw: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_doubt_withdraw", "treedetail_identity_sheet_doubt_withdraw", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6481, 72),
      ))
    }

@delegate:ResourceContentHash(-214_905)
internal val Res.string.treedetail_identity_sheet_note_label: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_note_label", "treedetail_identity_sheet_note_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6646, 52),
      ))
    }

@delegate:ResourceContentHash(-141_137_110)
internal val Res.string.treedetail_identity_sheet_note_placeholder: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_note_placeholder", "treedetail_identity_sheet_note_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6699, 102),
      ))
    }

@delegate:ResourceContentHash(-1_229_526_983)
internal val Res.string.treedetail_identity_sheet_note_reason_label: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_note_reason_label", "treedetail_identity_sheet_note_reason_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6802, 75),
      ))
    }

@delegate:ResourceContentHash(-903_551_769)
internal val Res.string.treedetail_identity_sheet_note_reason_placeholder: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_note_reason_placeholder", "treedetail_identity_sheet_note_reason_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6878, 81),
      ))
    }

@delegate:ResourceContentHash(681_708_253)
internal val Res.string.treedetail_identity_sheet_note_title: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_note_title", "treedetail_identity_sheet_note_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6960, 68),
      ))
    }

@delegate:ResourceContentHash(-2_083_757_757)
internal val Res.string.treedetail_identity_sheet_probable: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_probable", "treedetail_identity_sheet_probable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7148, 54),
      ))
    }

@delegate:ResourceContentHash(213_778_936)
internal val Res.string.treedetail_identity_sheet_probable_description: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_probable_description", "treedetail_identity_sheet_probable_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7029, 118),
      ))
    }

@delegate:ResourceContentHash(1_037_426_819)
internal val Res.string.treedetail_identity_sheet_reason_label: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_reason_label", "treedetail_identity_sheet_reason_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7203, 78),
      ))
    }

@delegate:ResourceContentHash(-1_735_179_231)
internal val Res.string.treedetail_identity_sheet_reason_placeholder: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_reason_placeholder", "treedetail_identity_sheet_reason_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7282, 88),
      ))
    }

@delegate:ResourceContentHash(1_467_503_690)
internal val Res.string.treedetail_identity_sheet_remove: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_remove", "treedetail_identity_sheet_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7371, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("treedetail_back_description", Res.string.treedetail_back_description)
  map.put("treedetail_certainty_certain", Res.string.treedetail_certainty_certain)
  map.put("treedetail_certainty_probable", Res.string.treedetail_certainty_probable)
  map.put("treedetail_certainty_to_confirm", Res.string.treedetail_certainty_to_confirm)
  map.put("treedetail_confidence_disclaimer", Res.string.treedetail_confidence_disclaimer)
  map.put("treedetail_confidence_label", Res.string.treedetail_confidence_label)
  map.put("treedetail_confidence_lookalike_collapse", Res.string.treedetail_confidence_lookalike_collapse)
  map.put("treedetail_confidence_lookalike_expand", Res.string.treedetail_confidence_lookalike_expand)
  map.put("treedetail_confidence_lookalike_title", Res.string.treedetail_confidence_lookalike_title)
  map.put("treedetail_confidence_owner_note", Res.string.treedetail_confidence_owner_note)
  map.put("treedetail_confidence_owner_note_disputed", Res.string.treedetail_confidence_owner_note_disputed)
  map.put("treedetail_confidence_report_cta", Res.string.treedetail_confidence_report_cta)
  map.put("treedetail_confidence_subtitle_disputed", Res.string.treedetail_confidence_subtitle_disputed)
  map.put("treedetail_creator_added_recently", Res.string.treedetail_creator_added_recently)
  map.put("treedetail_default_username", Res.string.treedetail_default_username)
  map.put("treedetail_delete_dialog_cancel", Res.string.treedetail_delete_dialog_cancel)
  map.put("treedetail_delete_dialog_confirm", Res.string.treedetail_delete_dialog_confirm)
  map.put("treedetail_delete_dialog_text", Res.string.treedetail_delete_dialog_text)
  map.put("treedetail_delete_dialog_title", Res.string.treedetail_delete_dialog_title)
  map.put("treedetail_directions", Res.string.treedetail_directions)
  map.put("treedetail_failed_photos_remove", Res.string.treedetail_failed_photos_remove)
  map.put("treedetail_failed_photos_retry", Res.string.treedetail_failed_photos_retry)
  map.put("treedetail_failed_photos_text_many", Res.string.treedetail_failed_photos_text_many)
  map.put("treedetail_failed_photos_text_one", Res.string.treedetail_failed_photos_text_one)
  map.put("treedetail_failed_photos_title_many", Res.string.treedetail_failed_photos_title_many)
  map.put("treedetail_failed_photos_title_one", Res.string.treedetail_failed_photos_title_one)
  map.put("treedetail_field_creation", Res.string.treedetail_field_creation)
  map.put("treedetail_field_note", Res.string.treedetail_field_note)
  map.put("treedetail_field_position", Res.string.treedetail_field_position)
  map.put("treedetail_field_species", Res.string.treedetail_field_species)
  map.put("treedetail_harvest_status_cancelled", Res.string.treedetail_harvest_status_cancelled)
  map.put("treedetail_harvest_status_completed", Res.string.treedetail_harvest_status_completed)
  map.put("treedetail_harvest_status_expired", Res.string.treedetail_harvest_status_expired)
  map.put("treedetail_harvest_status_ongoing", Res.string.treedetail_harvest_status_ongoing)
  map.put("treedetail_harvest_status_planned", Res.string.treedetail_harvest_status_planned)
  map.put("treedetail_hazard_lookalike_note", Res.string.treedetail_hazard_lookalike_note)
  map.put("treedetail_hazard_title", Res.string.treedetail_hazard_title)
  map.put("treedetail_header_added_by", Res.string.treedetail_header_added_by)
  map.put("treedetail_header_added_by_me", Res.string.treedetail_header_added_by_me)
  map.put("treedetail_history_author_line", Res.string.treedetail_history_author_line)
  map.put("treedetail_history_author_unnamed", Res.string.treedetail_history_author_unnamed)
  map.put("treedetail_history_changed", Res.string.treedetail_history_changed)
  map.put("treedetail_history_current", Res.string.treedetail_history_current)
  map.put("treedetail_history_error_title", Res.string.treedetail_history_error_title)
  map.put("treedetail_history_import_bordeaux", Res.string.treedetail_history_import_bordeaux)
  map.put("treedetail_history_import_grenoble", Res.string.treedetail_history_import_grenoble)
  map.put("treedetail_history_import_lozere", Res.string.treedetail_history_import_lozere)
  map.put("treedetail_history_import_lyon", Res.string.treedetail_history_import_lyon)
  map.put("treedetail_history_import_metz", Res.string.treedetail_history_import_metz)
  map.put("treedetail_history_import_montpellier", Res.string.treedetail_history_import_montpellier)
  map.put("treedetail_history_import_nantes", Res.string.treedetail_history_import_nantes)
  map.put("treedetail_history_import_osm", Res.string.treedetail_history_import_osm)
  map.put("treedetail_history_import_paris", Res.string.treedetail_history_import_paris)
  map.put("treedetail_history_import_plaine_commune", Res.string.treedetail_history_import_plaine_commune)
  map.put("treedetail_history_import_rennes", Res.string.treedetail_history_import_rennes)
  map.put("treedetail_history_import_strasbourg", Res.string.treedetail_history_import_strasbourg)
  map.put("treedetail_history_import_toulouse", Res.string.treedetail_history_import_toulouse)
  map.put("treedetail_history_moved", Res.string.treedetail_history_moved)
  map.put("treedetail_history_moved_back", Res.string.treedetail_history_moved_back)
  map.put("treedetail_history_no_certainty", Res.string.treedetail_history_no_certainty)
  map.put("treedetail_history_note_added", Res.string.treedetail_history_note_added)
  map.put("treedetail_history_note_cleared", Res.string.treedetail_history_note_cleared)
  map.put("treedetail_history_note_edited", Res.string.treedetail_history_note_edited)
  map.put("treedetail_history_reason", Res.string.treedetail_history_reason)
  map.put("treedetail_history_redacted", Res.string.treedetail_history_redacted)
  map.put("treedetail_history_reverted", Res.string.treedetail_history_reverted)
  map.put("treedetail_history_subtitle", Res.string.treedetail_history_subtitle)
  map.put("treedetail_history_title", Res.string.treedetail_history_title)
  map.put("treedetail_history_truncated", Res.string.treedetail_history_truncated)
  map.put("treedetail_identity_add_note", Res.string.treedetail_identity_add_note)
  map.put("treedetail_identity_correct", Res.string.treedetail_identity_correct)
  map.put("treedetail_identity_edit_note", Res.string.treedetail_identity_edit_note)
  map.put("treedetail_identity_footer_corrected", Res.string.treedetail_identity_footer_corrected)
  map.put("treedetail_identity_footer_corrected_mine", Res.string.treedetail_identity_footer_corrected_mine)
  map.put("treedetail_identity_footer_inventory", Res.string.treedetail_identity_footer_inventory)
  map.put("treedetail_identity_footer_moderation", Res.string.treedetail_identity_footer_moderation)
  map.put("treedetail_identity_footer_never", Res.string.treedetail_identity_footer_never)
  map.put("treedetail_identity_footer_osm", Res.string.treedetail_identity_footer_osm)
  map.put("treedetail_identity_history", Res.string.treedetail_identity_history)
  map.put("treedetail_identity_move", Res.string.treedetail_identity_move)
  map.put("treedetail_identity_note_empty", Res.string.treedetail_identity_note_empty)
  map.put("treedetail_identity_note_label", Res.string.treedetail_identity_note_label)
  map.put("treedetail_identity_position_label", Res.string.treedetail_identity_position_label)
  map.put("treedetail_identity_sheet_certain", Res.string.treedetail_identity_sheet_certain)
  map.put("treedetail_identity_sheet_certain_description", Res.string.treedetail_identity_sheet_certain_description)
  map.put("treedetail_identity_sheet_certainty_title", Res.string.treedetail_identity_sheet_certainty_title)
  map.put("treedetail_identity_sheet_close", Res.string.treedetail_identity_sheet_close)
  map.put("treedetail_identity_sheet_current", Res.string.treedetail_identity_sheet_current)
  map.put("treedetail_identity_sheet_doubt", Res.string.treedetail_identity_sheet_doubt)
  map.put("treedetail_identity_sheet_doubt_withdraw", Res.string.treedetail_identity_sheet_doubt_withdraw)
  map.put("treedetail_identity_sheet_note_label", Res.string.treedetail_identity_sheet_note_label)
  map.put("treedetail_identity_sheet_note_placeholder", Res.string.treedetail_identity_sheet_note_placeholder)
  map.put("treedetail_identity_sheet_note_reason_label", Res.string.treedetail_identity_sheet_note_reason_label)
  map.put("treedetail_identity_sheet_note_reason_placeholder", Res.string.treedetail_identity_sheet_note_reason_placeholder)
  map.put("treedetail_identity_sheet_note_title", Res.string.treedetail_identity_sheet_note_title)
  map.put("treedetail_identity_sheet_probable", Res.string.treedetail_identity_sheet_probable)
  map.put("treedetail_identity_sheet_probable_description", Res.string.treedetail_identity_sheet_probable_description)
  map.put("treedetail_identity_sheet_reason_label", Res.string.treedetail_identity_sheet_reason_label)
  map.put("treedetail_identity_sheet_reason_placeholder", Res.string.treedetail_identity_sheet_reason_placeholder)
  map.put("treedetail_identity_sheet_remove", Res.string.treedetail_identity_sheet_remove)
}
